export default __webpack_public_path__ + "static/menu-bg-7997bef916fdb69c0a6649de1d09b5ea.jpg";